import { render } from "./forms.vue?vue&type=template&id=900956d6"
import script from "./forms.vue?vue&type=script&lang=js"
export * from "./forms.vue?vue&type=script&lang=js"
script.render = render

export default script